/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
import type { ObservabilityProjectProductTierInfo } from './types'

const observabilityTiersOptions: ObservabilityProjectProductTierInfo[] = [
  {
    slug: 'logs_essentials',
    title: {
      id: 'createProject.observability.subType.essentials.title',
      defaultMessage: 'Logs Essentials',
    },
    description: {
      id: 'createProject.observability.subType.essentials.description',
      defaultMessage: 'Store and analyze logs at enterprise scale.',
    },
    properties: [
      {
        id: 'createProject.observability.subType.essentials.property1',
        defaultMessage: 'Ad hoc log analysis',
      },
      {
        id: 'createProject.observability.subType.essentials.property2',
        defaultMessage: 'Visualizations and dashboards',
      },
      {
        id: 'createProject.observability.subType.essentials.property3',
        defaultMessage: 'Alerts and Notifications',
      },
    ],
  },
  {
    slug: 'complete',
    title: {
      id: 'createProject.observability.subType.complete.title',
      defaultMessage: 'Complete',
    },
    description: {
      id: 'createProject.observability.subType.complete.description',
      defaultMessage: 'Full stack observability for cloud-native and hybrid environments.',
    },
    properties: [
      {
        id: 'createProject.observability.subType.complete.property1',
        defaultMessage: 'Everything included in Observability Logs Essentials',
      },
      {
        id: 'createProject.observability.subType.complete.property2',
        defaultMessage:
          'Fully curated experiences for analysis of logs, metrics, traces, and synthetics data',
      },
      {
        id: 'createProject.observability.subType.complete.property3',
        defaultMessage: 'Machine learning and AIOps capabilities',
      },
      {
        id: 'createProject.observability.subType.complete.property4',
        defaultMessage: 'Elastic AI Assistant and custom knowledge bases',
      },
      {
        id: 'createProject.observability.subType.complete.property5',
        defaultMessage: 'Service Level Objectives',
      },
    ],
  },
]

export default observabilityTiersOptions
